import { SvgIcon, SvgIconProps } from '@mui/material'

export const ReportingLicensesSidebar = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon role="img" viewBox="0 0 17 17" fill="none" {...props}>
      <path
        d="M5.59961 15.5996H10.5996M5.59961 15.5996V11.4329M5.59961 15.5996H1.19961C0.868239 15.5996 0.599609 15.331 0.599609 14.9996V12.0329C0.599609 11.7016 0.868239 11.4329 1.19961 11.4329H5.59961M10.5996 15.5996V5.59961M10.5996 15.5996H14.9996C15.331 15.5996 15.5996 15.331 15.5996 14.9996V1.19961C15.5996 0.868239 15.331 0.599609 14.9996 0.599609H11.1996C10.8682 0.599609 10.5996 0.868239 10.5996 1.19961V5.59961M10.5996 5.59961H6.19961C5.86824 5.59961 5.59961 5.86824 5.59961 6.19961V11.4329"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        vectorEffect="non-scaling-stroke"
      />
    </SvgIcon>
  )
}
